export default __webpack_public_path__ + "app/images/bw-mg-leave.svg";